import React from 'react'
import Explorer from '../../components/Explorer'

/**
 * Drawer izquierdo de series (shell OHIF).
 * Misma API que StudioSeriesRail; presentación en ohif.css.
 */
function OhifSeriesDrawer({
  explorer,
  onSelectSeries,
  color,
  autoSelectFirstSeries,
  onAutoShowExplorer,
  ...explorerExtras
}) {
  return (
    <div className="udv-ohif-drawer-inner">
      <div className="udv-ohif-drawer-label">Series</div>
      <div className="udv-ohif-drawer-body">
        <Explorer
          explorer={explorer}
          onSelectSeries={onSelectSeries}
          color={color}
          isMobile={false}
          embedded
          autoSelectFirstSeries={autoSelectFirstSeries}
          onAutoShowExplorer={onAutoShowExplorer}
          {...explorerExtras}
        />
      </div>
    </div>
  )
}

export default OhifSeriesDrawer
